import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/drob/telesOcene";
const baseUrlProperties = "/api/sif/drob/telesOceneLastnosti";
const baseUrlDescriptive = "/api/sif/drob/telesOceneOpisno";

/**
 * GET /api/sif/drob/telesOcene/page
 */
export const fetchPhysicalAssessmentPropertyValuesPage = createAsyncThunk(
  "physicalAssessmentValues/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

/**
 * GET /api/sif/drob/telesOceneLastnosti/page
 */
export const fetchPhysicalAssessmentPropertiesPage = createAsyncThunk(
  "physicalAssessmentProperties/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrlProperties}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchPhysicalAssessmentDescriptivePage = createAsyncThunk(
  "physicalAssessmentDescriptive/list",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrlDescriptive}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const physicalAssessmentDescriptiveSlice = createSlice({
  name: "physicalAssessmentDescriptive",
  initialState: {
    scoreOptionsList: [],
    descriptiveOptionsList: [],
    qualitativeOptionsList: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    /* Sifranti */
    builder
      .addCase(fetchPhysicalAssessmentPropertyValuesPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchPhysicalAssessmentPropertyValuesPage.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.scoreOptionsList = action.payload?.content || [];
        }
      )
      .addCase(
        fetchPhysicalAssessmentPropertyValuesPage.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      );
    /* Opisne lastnosti */
    builder
      .addCase(fetchPhysicalAssessmentPropertiesPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchPhysicalAssessmentPropertiesPage.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.descriptiveOptionsList = action.payload?.content || [];
        }
      )
      .addCase(
        fetchPhysicalAssessmentPropertiesPage.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      );
    /* Kakovostne ocene */
    builder
      .addCase(fetchPhysicalAssessmentDescriptivePage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchPhysicalAssessmentDescriptivePage.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.qualitativeOptionsList = action.payload?.content || [];
        }
      )
      .addCase(
        fetchPhysicalAssessmentDescriptivePage.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      );
  },
});

export default physicalAssessmentDescriptiveSlice.reducer;
